import { c as _c } from "react/compiler-runtime";
import { Card, CardContent } from '@achra/ui/card';
import { Skeleton } from '@achra/ui/skeleton';
interface ServiceInfoSkeletonProps {
  /** Matches ServiceInfo `isCompacted` (dense header in purchase wizard). */
  isCompacted?: boolean;
  /** Operator badge row (avatar + code + name). */
  showOperatorBadge?: boolean;
  /** Product info step: "Select an operator" action placement. */
  showSelectOperatorAction?: boolean;
}

/** Stands in for `OperatorBadge` (avatar + operator code + name). */
function OperatorBadgeSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="size-6 shrink-0 rounded-full" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-2">{t0}<div className="flex items-center gap-1"><Skeleton className="h-5 w-8" /><Skeleton className="h-5 w-30 max-w-36 min-w-0" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function ServiceInfoSkeleton(t0) {
  const $ = _c(25);
  const {
    isCompacted: t1,
    showOperatorBadge: t2,
    showSelectOperatorAction: t3
  } = t0;
  const isCompacted = t1 === undefined ? false : t1;
  const showOperatorBadge = t2 === undefined ? false : t2;
  const showSelectOperatorAction = t3 === undefined ? false : t3;
  if (isCompacted) {
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Skeleton className="size-14! min-w-14! shrink-0 rounded-full" />;
      $[0] = t4;
    } else {
      t4 = $[0];
    }
    let t5;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Skeleton className="h-5 w-full max-w-32 lg:h-7 lg:max-w-48" />;
      $[1] = t5;
    } else {
      t5 = $[1];
    }
    let t6;
    if ($[2] !== showOperatorBadge) {
      t6 = showOperatorBadge && <OperatorBadgeSkeleton />;
      $[2] = showOperatorBadge;
      $[3] = t6;
    } else {
      t6 = $[3];
    }
    let t7;
    if ($[4] !== t6) {
      t7 = <Card className="border-none bg-transparent p-0 shadow-none"><CardContent className="flex flex-row items-center gap-2 px-0">{t4}<div className="flex min-w-0 flex-1 flex-col gap-3 lg:gap-2">{t5}{t6}</div></CardContent></Card>;
      $[4] = t6;
      $[5] = t7;
    } else {
      t7 = $[5];
    }
    return t7;
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Skeleton className="h-5 w-full max-w-xs sm:hidden" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Skeleton className="h-32 w-full rounded-lg sm:size-32 sm:min-w-32 md:size-64 md:min-w-64 md:rounded-2xl" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex flex-col gap-2 sm:gap-4">{t5}<div className="flex flex-col gap-2"><div className="bg-accent flex h-9 w-full items-center justify-center gap-2 rounded-md"><Skeleton className="bg-border h-5 w-24" /><Skeleton className="bg-border size-4 shrink-0" /></div></div></div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Skeleton className="hidden h-6 w-full max-w-lg sm:block" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== showOperatorBadge) {
    t8 = showOperatorBadge && <OperatorBadgeSkeleton />;
    $[10] = showOperatorBadge;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex flex-col gap-2"><Skeleton className="h-4.5 w-full max-w-xl" /><Skeleton className="h-4.5 w-full max-w-2xl" /><Skeleton className="h-4.5 w-full max-w-md sm:max-w-lg" /><Skeleton className="h-4.5 w-2/5 max-w-32 sm:hidden" /></div>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8) {
    t10 = <div className="flex w-full flex-col gap-4 lg:gap-4">{t7}{t8}{t9}</div>;
    $[13] = t8;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== showSelectOperatorAction) {
    t11 = showSelectOperatorAction && <div className="flex items-end justify-end sm:hidden lg:flex"><Skeleton className="h-9 w-full max-w-44" /></div>;
    $[15] = showSelectOperatorAction;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11) {
    t12 = <CardContent className="flex flex-col gap-4 px-0 sm:flex-row lg:gap-6">{t4}{t6}{t10}{t11}</CardContent>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== showSelectOperatorAction) {
    t13 = showSelectOperatorAction && <div className="hidden items-end justify-end sm:flex lg:hidden"><Skeleton className="h-9 w-full max-w-48" /></div>;
    $[20] = showSelectOperatorAction;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t12 || $[23] !== t13) {
    t14 = <Card className="border-none bg-transparent p-0 shadow-none">{t12}{t13}</Card>;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
}
export { ServiceInfoSkeleton };